// src/helpers/screenText.ts
// Kho text hiển thị (label, tên cột, nút, placeholder, thông báo...) theo từng màn hình, đọc từ MỘT file JSON
// duy nhất để dễ bảo trì: src/locales/screens.json
//
//   {
//     "ten_man_hinh": {
//       "ten_label": "giá trị hiển thị"
//     }
//   }
//
// Cách dùng trong component:
//   const st = useScreenText('user_management');
//   <Label>{st('name_label')}</Label>
//   toast.success(st('toast_deleted', { name: user.name }));   // "Đã xóa {{name}}"
//
// Muốn đổi chữ => sửa screens.json, không cần đụng code. Thiếu key => hiển thị chính key (dễ phát hiện) và
// cảnh báo ở console khi chạy development.
import { useMemo } from 'react';
import screens from 'locales/screens.json';

type ScreenTexts = Record<string, Record<string, string>>;
export type ScreenTextParams = Record<string, unknown>;

const texts = screens as ScreenTexts;

export const getScreenText = (screen: string, key: string, params?: ScreenTextParams): string => {
  const value = texts[screen]?.[key];
  if (value === undefined) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[screenText] Thiếu text: "${screen}.${key}" trong src/locales/screens.json`);
    }
    return key;
  }
  if (!params) return value;
  // Thay {{tham_so}} bằng giá trị truyền vào.
  return value.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name: string) => String(params[name] ?? ''));
};

// Tạo hàm lấy text cho 1 màn hình ở cấp module (dùng được ngoài component: hằng số, thunk, helper...):
//   const st = createScreenText('user_management');
export const createScreenText = (screen: string) => (key: string, params?: ScreenTextParams) =>
  getScreenText(screen, key, params);

export const useScreenText = (screen: string) =>
  useMemo(() => (key: string, params?: ScreenTextParams) => getScreenText(screen, key, params), [screen]);
